var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEveryUser(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 74,
    viewBox: "0 0 75 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.8626 52.4167C26.1198 52.4167 29.571 48.9655 29.571 44.7083C29.571 40.4511 26.1198 37 21.8626 37C17.6054 37 14.1543 40.4511 14.1543 44.7083C14.1543 48.9655 17.6054 52.4167 21.8626 52.4167Z",
    fill: "#F8BF3E",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.6966 52.4167C56.9538 52.4167 60.4049 48.9655 60.4049 44.7083C60.4049 40.4511 56.9538 37 52.6966 37C48.4394 37 44.9883 40.4511 44.9883 44.7083C44.9883 48.9655 48.4394 52.4167 52.6966 52.4167Z",
    fill: "#F8BF3E",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2786 21.5837C41.5358 21.5837 44.987 18.1325 44.987 13.8753C44.987 9.61813 41.5358 6.16699 37.2786 6.16699C33.0215 6.16699 29.5703 9.61813 29.5703 13.8753C29.5703 18.1325 33.0215 21.5837 37.2786 21.5837Z",
    fill: "#F8BF3E",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2786 67.8337C37.2786 59.3193 30.3763 52.417 21.862 52.417C13.3476 52.417 6.44531 59.3193 6.44531 67.8337",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M68.1126 67.8337C68.1126 59.3193 61.2103 52.417 52.696 52.417C44.1816 52.417 37.2793 59.3193 37.2793 67.8337",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M52.6966 36.9997C52.6966 28.4854 45.7943 21.583 37.2799 21.583C28.7656 21.583 21.8633 28.4854 21.8633 36.9997",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEveryUser);
export default __webpack_public_path__ + "static/media/every-user.3363eeac88e24a19c078517202d664f2.svg";
export { ForwardRef as ReactComponent };